import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

const fetchAuthenticateToken = (token) => {
  return api.get(`/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
};

export const useAuthenticateTokenQuery = (token) => {
  return useQuery({
    queryKey: ["authenticateToken", token],
    queryFn: () => fetchAuthenticateToken(token),
    enabled: !!token,
    select: (data) => {
      return data.data;
    },
  });
};
